import type { FC } from 'react';
export const PvValueSkeleton: FC = () => {
  return (
    <>
      <div className="flex h-5 items-center justify-end">
        <div className="h-3 w-16 animate-pulse rounded bg-white/10" />
      </div>
      <div className="flex h-4 items-center justify-end">
        <div className="h-2.5 w-12 animate-pulse rounded bg-white/10" />
      </div>
    </>
  );
};
